module.exports = __webpack_public_path__ + "img/no-avatar-image-male.0abcb71d.jpg";